import { Component } from '@angular/core';

@Component({
  selector: 'my-alerts-configurations',
  templateUrl: './my-alerts-configuration.component.html',
  styleUrls: ['./my-alerts-configuration.component.scss']
})
export class MyAlertsConfigurationComponent { }
